import { afterNextRender, Directive, ElementRef, inject, OnDestroy } from '@angular/core';

/**
 * Blendet ein Element beim Scrollen sanft ein.
 * Läuft nur im Browser – bei SSR bleibt der Inhalt sichtbar (die versteckende
 * Klasse wird erst clientseitig gesetzt).
 */
@Directive({
  selector: '[mbReveal]',
  standalone: true,
})
export class RevealDirective implements OnDestroy {
  private readonly host = inject(ElementRef<HTMLElement>);
  private observer?: IntersectionObserver;

  constructor() {
    afterNextRender(() => {
      const el = this.host.nativeElement as HTMLElement;
      if (!('IntersectionObserver' in window)) return;

      el.classList.add('mb-rv');
      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('mb-rv--in');
            this.observer?.unobserve(entry.target);
          }
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      this.observer.observe(el);
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
